import { parsePhoneNumber } from "awesome-phonenumber";

const US_REGION_CODE = "US";

const formatPhoneNumber = (value?: string): string | undefined => {
  const { valid: isValid, number: phoneNumber, regionCode } = parsePhoneNumber(`+${value}`);

  if (!isValid) {
    return undefined;
  }

  const isUs = regionCode === US_REGION_CODE;

  const { international, national } = phoneNumber;

  const result = isUs
    ? national
    : international;

  return result;
};

export default formatPhoneNumber;
